/**
 * Maps GET /deals/mine/ (and similar) failures to user-visible text.
 * Handles nested DRF bodies and network/baseURL issues.
 */

export function formatDealsLoadError(err) {
  const status = err.response?.status;
  const data = err.response?.data;
  const nested = data?.error ?? (typeof data?.detail === 'object' ? data.detail?.error : null);
  const code = nested?.code ?? data?.code;
  const message = nested?.message ?? data?.message ?? data?.detail;

  if (!err.response) {
    return (
      'Cannot reach the API. Check that the backend is running and ' +
      'REACT_APP_API_BASE_URL matches the server (e.g. http://127.0.0.1:8000).'
    );
  }

  if (status === 401) {
    return 'Your session has expired. Please sign in again.';
  }

  if (code === 'ANONYMOUS_ID_NOT_FOUND') {
    return (
      'No anonymous marketplace ID is linked to your account yet. Complete registration/KYC, ' +
      'or contact support if this persists.'
    );
  }

  if (code === 'DEAL_LIST_FORBIDDEN') {
    return 'Only buyer and bidder accounts can list deals.';
  }

  if (status >= 500) {
    return (
      'Server error while loading deals. If you recently updated CMP, run database migrations ' +
      'on the backend (`python manage.py migrate`) and restart the API, then try again.'
    );
  }

  if (typeof message === 'string' && message.length > 0 && !message.includes('[object Object]')) {
    return `${message} (HTTP ${status})`;
  }

  return `Could not load deals (HTTP ${status}).`;
}
